// UrlOAuthLoginLoader.js
import { connect } from 'react-redux';
import loadUrlOAuthLogin from '../action/loadUrlOAuthLogin.js';
import UrlLoader from '../component/UrlLoader.jsx';

const mapDispatchToProps = dispatch => {
  return {
    urlHandler: ({ url }) => dispatch(loadUrlOAuthLogin({ url })),
  };
};

export default connect(null, mapDispatchToProps)(UrlLoader);
